import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Tooltip ,
  IconButton ,
  CircularProgress,
  Modal,
  InputLabel,
  Select,
  Grid,
  MenuItem,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Alert, 
  AlertTitle, 
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetEmailDL, getSalesOffices } from "../../utils/GetAdmin";
import { saveEmailDL } from "../../utils/PostAdmin";
import requestMissingContexts, {displayConfig } from "../../utils/GetContext";
import TableAbstraction from "../../componentUtils/TableAbstraction";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import Clear from "@mui/icons-material/Clear";
import { deleteAccessConfig, getAllAccessConfigs, saveAccessConfig } from "../../utils/GetAdmin";

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalGrid: {
      marginTop: theme.spacing(2),
    },
    modalTitle:{
      color: theme.palette.primary.main,
    },
    modalCard: {
    },
    modalText: {
      width: 800,
    },
    modalInput: {
      paddingLeft: "2px", 
      paddingRight: "20px", 
      width:"300px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
interface rowData {
  param_value: string;
  email: string;
  guid:string;
  sales_org:string;

}
export default function AdminAccessConfig() {
  const classes = useStyles();
  const [deliveringPlants, setDeliveringPlants] = React.useState<any>();
  const [accessConfigs, SetAccessConfigs] = useState<any[]>([]);
  const [codes, setCodes] = React.useState<any>();
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", 100);
  const enabled = checkForRole(`${clientId}`,salesOrg,'vp_admin');
  const [useCompact] = useLocalStorage("SETTINGS.compact", true);

  
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});

  const [confirmDelete, setConfirmDelete] = React.useState<boolean>(false);

  const [selRow, setSelRow] = React.useState<rowData|undefined>(undefined);

  const [editedRowDeliveringPlant, setEditedRowDeliveringPlant] = React.useState<string>("");
  const [editedRowEmail, setEditedRowEmail] = React.useState<string>("");

  const [modalStyle] = React.useState(getModalStyle);
  const [openEditWindow, setOpenEditWindow] = React.useState(false);
  const handleModalClose = () => {
    setOpenEditWindow(false);
    //setEditedRow(undefined);
    setEditedRowDeliveringPlant("");
    setEditedRowEmail("");
  }

  
  const handleModalSave = () => {
    //let oldEmail = (editedRow) ? {deliveringPlant: editedRow.deliveringPlant, salesOffice: editedRow.deliveringPlant, dlName:editedRow.dlName, email:editedRow.email} : undefined;
    //let newConfig = {deliveringPlant: editedRowDeliveringPlant, email:editedRowEmail};
    saveAccessConfig(salesOrg,editedRowEmail,editedRowDeliveringPlant).then(ret => {
      if(ret && ret.data){
        SetAccessConfigs(ret.data)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
    setOpenEditWindow(false);
    setSelRow(undefined);
  } 
  const handleDelete = () => {
    //let oldEmail = {deliveringPlant: editedRowDeliveringPlant, email:editedRowEmail};
    if(selRow&&selRow.guid){
    deleteAccessConfig(salesOrg,selRow?.guid).then(ret => {
      if(ret && ret.data){
        SetAccessConfigs(ret.data)
        if(ret.data.message){
          alert(ret.data.message);
        }
      }
    });
}

    setSelRow(undefined);
  }

const modalBody = (
  <div style={modalStyle} className={classes.paper} >
  <Typography variant="h4" className={classes.modalTitle} paragraph>Access Configuration</Typography>
  <Grid container spacing={2}  className={classes.modalGrid}>
    <Grid item xs={14} md={14} xl={12}>
      {/* <Typography variant="subtitle1" className={classes.modalText} paragraph>
        
      </Typography> */}
      <Card className={classes.modalCard}>
        <CardContent>
        <Grid container rowSpacing={3} className={classes.modalGrid}>
        <Grid item xs={6} md={6} xl={6}>
            <InputLabel >Email</InputLabel>
            <TextField placeholder='Email' type='text'
                className={classes.modalInput}
                value={editedRowEmail}
                onChange={(e) => { 
                  setEditedRowEmail((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "") 
                }}></TextField>
            </Grid>
          <Grid item xs={3} md={6} xl={6}>
            <InputLabel >Delivery Plant</InputLabel>
            <Select label="Delivery Plant" required placeholder='Delivery Plant' value={editedRowDeliveringPlant}
                inputProps={{name: 'Delivery Plant',}}
                className={classes.modalInput}
                onChange={(e) => { 
                    setEditedRowDeliveringPlant((e.target.value &&  typeof e.target.value == 'string') ? e.target.value : "*"); 
                    }}>
                <MenuItem key='*' value='*'>{salesOrg + " - All"}</MenuItem>
                {(deliveringPlants)?(Object.entries(deliveringPlants).map((so: any, i: number) => (
                  
                    <MenuItem key={so[1].code} value={so[1].code}>
                      {so[1].code + " - " + so[1].text}
                    </MenuItem>
                    ))):(<div></div>)}
            </Select>
          </Grid>
          </Grid>
          </CardContent>
        </Card>
        <div style={{ paddingRight: "5px", textAlign:"right"}}>
              <React.Fragment>
                  <Tooltip title={"Save"}>
                      <IconButton onClick={handleModalSave}>
                          <SaveIcon />
                      </IconButton>
                  </Tooltip>
                  <Tooltip title={"Cancel"}>
                      <IconButton onClick={handleModalClose}>
                          <Clear />
                      </IconButton>
                  </Tooltip>
              </React.Fragment>
            </div>
      </Grid>
    </Grid>
  </div>
);

  useEffect(() => {
    if (doneLoading) return;
    requestMissingContexts(["SALESOFFICES", "PLANTS"])
      .then((v) => {
        setCodes(v);
      })
      .then((_) => {
        getAllAccessConfigs(salesOrg).then((v) => {
            if(v && v.data) SetAccessConfigs(v.data);
          }).then((_) => {
            getSalesOffices(salesOrg)
            .then((v) => {
              setDeliveringPlants(v);
              setEditedRowDeliveringPlant("*");
              setDoneLoading(true);
            });
            });
      });
  }, [accessConfigs,doneLoading,salesOrg,muiTable,confirmDelete]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <TableAbstraction
        settingsKey="ADM_ACCESS_CONFIG"
          options={{
            draggableColumns: {
              enabled: true,
            },
            rowsPerPageOptions: [25, 50, 100],
            serverSide: false,
            selectableRows: "none",
            rowsPerPage: muiTable.rpp,
            onChangeRowsPerPage: (numberOfRows) => {
              muiTable.rpp = numberOfRows;
              setMuiTable(muiTable);
            },
            customToolbar: () => {
              return (
                <Tooltip title={`Add Access Configs`}>
                  <IconButton  onClick={() => {
                    handleModalClose();
                    setOpenEditWindow(true);
                  }}>
                    <AddIcon />
                  </IconButton>
                </Tooltip>
              );
            },
          }}
          title="Access Configurations"
          columns={[
            {
                label: "Sales Org",
                name: "sales_org",
                options: {
                  searchable: true,
                  filter: false,
                },
            },
            {
                label: "Email Address",
                name: "email",
                options: {
                  searchable: true,
                  filter: false,
                },
            },
            // {
            //   label: "AccessType",
            //   name: "accesstype",
            //   options: {
            //     filter: true,
            //     customBodyRender: (value: any) => {
            //       return (
            //         <Tooltip title={`Recieve access to provided type`}>
            //           <div>
            //           {value}
            //           </div>
            //         </Tooltip>
            //       );
            //     },
            //   },
            // },
            {
                label: "Plants",
                name: "param_value",
                options: {
                  filter: true,
                  customBodyRender: (value: any) => {
                    return (
                      <Tooltip title={`Plants having access to`}>
                        <div>
                        {value}
                        </div>
                      </Tooltip>
                    );
                  },
                },
              },
            {
              label: " ",
              name: "remove",
              options: {
                filter: false,
                setCellProps: () => ({ align: 'right' }),
                renderCell: (props) => {
                  const tableMeta = props.row;
                    if(!!useCompact)
                    return (
                        <React.Fragment>
                          <Tooltip title={"Delete"}>
                            <DeleteIcon
                              fontSize="small" 
                              onClick={() => {
                                setSelRow(tableMeta); setConfirmDelete(true);
                              }} 
                            />
                          </Tooltip>
                        </React.Fragment>
                      );
                    else
                      return (
                          <React.Fragment>
                            <Tooltip title={"Delete"}>
                              <IconButton onClick={() => {
                                  setSelRow(tableMeta); setConfirmDelete(true);
                              }}>
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </React.Fragment>
                        );
                }
              },
            },
          ]}
          data={accessConfigs}
        />
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
      
      <Modal
        open={openEditWindow}
        onClose={handleModalClose}
      >
        {modalBody}
      </Modal>

        <Dialog
          open={confirmDelete}
          onClose={()=>setConfirmDelete(false)}
        >
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you wish to delete the email {editedRowEmail}?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={()=>{handleDelete(); setConfirmDelete(false);}} color="primary">
              Yes
            </Button>
            <Button onClick={()=>{
                setSelRow(undefined);
                 setConfirmDelete(false);
            }} color="primary" autoFocus>
              No
            </Button>
          </DialogActions>
        </Dialog>
    </div>
  );
}